<template>
    <ul class="com-menu">
        <slot></slot>
    </ul>
</template>

<script>
export default {
    name: 'ComMenu'
};
</script>

<style lang="scss" scoped>
.com-menu {
    min-width: 100px;
    background-color: #24252c;
    font-size: 12px;
    line-height: 1;
    color: #ddd;
    padding-top: 4px;
    padding-bottom: 6px;
    border-radius: 6px;
}
</style>
